import React from 'react';
import TryThisOut from '../pages/tryNow/TryThisOut';

function AadharMasking({ currentProduct, mode, previewResponseImage }) {
  return (
    <>
      <TryThisOut
        currentProduct={currentProduct}
        mode={mode}
        previewResponseImage={previewResponseImage}
      />
    </>
  );
}

export default AadharMasking;
